import { InstrumentFixDraft, InstrumentFixSection } from "./types";

const compact = (draft: InstrumentFixDraft) =>
  Object.values(draft).some(Boolean) ? draft : null;

export const withFixSection = <S extends InstrumentFixSection>(
  current: InstrumentFixDraft | null,
  section: S,
  value: InstrumentFixDraft[S] | null,
) => compact({ ...current, [section]: value ?? undefined });

export const withoutPricingSections = (current: InstrumentFixDraft | null) =>
  compact({ country: current?.country });
